export const TRIP_PROTECTION_COVERAGE_OPTIONS = [
  {
    value: "emergency_evac_and_transport",
    label: "Emergency Evacuation & Transportation",
  },
  {
    value: "emergency_medical_and_dental",
    label: "Emergency Medical & Dental Insurance",
  },
];

export const TRIP_PROTECTION_COVERAGE_OPTIONS_WITHOUT_FINTECH = [
  { value: "trip_delays", label: "Trip Delays" },
  { value: "trip_accident", label: "Travel Accident Insurance" },
  ...TRIP_PROTECTION_COVERAGE_OPTIONS,
];

export const TRIP_PROTECTION_UPGRADE_BANNER_CTA_TEXT =
  "Upgrade your trip protection";

